import React, { useCallback, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import cmtIssueStageActions from "../../../_actions/_qmsActions/cmtIssueStageActions";
import ReactDatePicker from "react-datepicker";
import CustomDatePickerInput from "../../_common/CustomDatePickerInput";
import { addDays, isAfter, isBefore, isEqual } from "date-fns";
import { getLocalISOString } from "../../../_utils/generalUtils";

export default function CmtModal_IssueStageCompleted(props) {
  const { modalState, toggleModal, issueStage, issueId, divisionId } = props;

  const dispatch = useDispatch();

  const fetching = useSelector((state) => state.qms.fetching);

  const [completedOn, setCompletedOn] = useState(new Date());

  const futureDates = useCallback((date) => !isAfter(date, new Date()), [isAfter]);
  const completionDates = useCallback(
    (date) => {
      date.setHours(0, 0, 0, 0);
      const _startedOn = issueStage.startedOn
        ? new Date(new Date(issueStage.startedOn).setHours(0, 0, 0, 0))
        : null;
      return _startedOn
        ? (isAfter(date, _startedOn) || isEqual(date, _startedOn)) &&
            isBefore(date, addDays(new Date(new Date().setHours(0, 0, 0, 0)), 1))
        : futureDates(date);
    },
    [issueStage, futureDates]
  );

  const handleClick_submit = async (e) => {
    e.preventDefault();
    // Update the open issueStage
    await dispatch(
      cmtIssueStageActions.markCompleted(
        issueId,
        issueStage.issueStageId,
        getLocalISOString(completedOn)
      )
    );

    // Refresh the open issue to update the snippets
    dispatch(cmtIssueActions.get(issueId));
    dispatch(cmtIssueActions.getAll(divisionId));
    toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={modalState.showModal} toggle={toggleModal} fade={false} size={"md"}>
      <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="flag-checkered" className="fa-fw mr-2" />
        Stage Completion
      </ModalHeader>
      <ModalBody>
        <div className="form-row form-group mb-0">
          <label
            htmlFor="completedOn"
            className="col-md-4 col-form-label font-weight-bold mb-0"
          >
            Completed On:
          </label>
          <div className="col-md-8 ml-auto">
            <ReactDatePicker
              customInput={<CustomDatePickerInput />}
              name="completedOn"
              id="completedOn"
              selected={completedOn}
              dateFormat="MM/dd/yyyy (E)"
              onChange={(date) => setCompletedOn(date)}
              filterDate={completionDates}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-group form-row float-right mb-0">
          <button
            type="button"
            name="open"
            id="open"
            className="btn btn-primary mr-2"
            onClick={handleClick_submit}
          >
            {fetching && (
              <span className="mr-2 mt-1">
                <FontAwesomeIcon
                  icon="spinner"
                  className="loading-spinner"
                  style={{ color: "white" }}
                />
              </span>
            )}
            <b>OK</b>
          </button>
          <button
            type="button"
            name="cancel"
            id="cancel"
            className="btn btn-secondary"
            onClick={toggleModal}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
